module.exports = __webpack_public_path__ + "static/images/amex.YAeLcVR.svg";